import React from "react";
import LegalDocumentLayout from "./legal/LegalDocumentLayout";
import TermsandConditions from "../Components/Terms/TermsandConditions";

export default function TermsConditions() {
  return (
    <LegalDocumentLayout title="Terms & conditions">
      <TermsandConditions />
    </LegalDocumentLayout>
  );
}
